import { styled } from 'styled-components'
import { Block, InlineAlert, Paragraph, TextInput } from 'suomifi-ui-components'
import media from 'common-ui-components/src/vtj/theme/media'

export const FormContainer = styled(Block).attrs({ role: 'form' })`
  & > section {
    margin-top: ${({ theme }) => theme.spacing.m};
    margin-bottom: ${({ theme }) => theme.spacing.m};
    padding-top: 0;
    padding-bottom: 0;
    border-bottom: 1px solid ${({ theme }) => theme.colors.depthLight1};

    & > *:last-child {
      margin-bottom: ${({ theme }) => theme.spacing.m};
    }

    & > h2 + p,
    & > h3 + p,
    & > p + p {
      margin-top: ${({ theme }) => theme.spacing.m};
    }

    & > p {
      font: ${({ theme }) => theme.typography.bodyText};
    }
  }
  .fi-single-select {
    width: 100%;
  }
`

export const ParagraphWithNewlines = styled(Paragraph)`
  white-space: pre-wrap;
`

export const InfoInlineAlert = styled(InlineAlert).attrs(
  ({ status = 'neutral' }) => ({ status })
)`
  margin-top: ${({ theme }) => theme.spacing.s};

  p,
  p > a {
    ${({ theme }) => theme.typography.bodyTextSmall};
  }

  p + p {
    margin-top: ${({ theme }) => theme.spacing.s};
  }

  h3 + p,
  h4 + p,
  h5 + p,
  p + h3,
  p + h4,
  p + h5 {
    margin-top: ${({ theme }) => theme.spacing.s};
  }

  ul {
    padding: ${({ theme }) => theme.spacing.s}
      ${(props) => props.theme.spacing.m};
    list-style-type: disc;
    li {
      margin: 0;
      padding: 0;
    }
  }
`

export const TextInputs = styled(Block)`
  max-width: 85%;

  ${media.desktopMaxContent} {
    max-width: 70%;
  }

  ${media.mobileContent} {
    max-width: 90%;
  }
`

export const StyledTextInput = styled(TextInput)`
  margin: ${({ theme }) => theme.spacing.s} 0;
`

export const NonEditableField = styled(Block)`
  margin: ${({ theme }) => theme.spacing.s} 0;

  .fi-text--bold {
    ${({ theme }) => theme.typography.bodySemiBoldSmall}
  }

  p + p {
    margin-top: ${({ theme }) => theme.spacing.s};
  }
`
